import React from 'react';
import { ReactComponent as LogoDark } from '../../assets/logo_dark.svg';
import StKzPdf from '../../assets/CT-KZ-Certificate.pdf'; // Import the PDF

const Footer = () => {
  return (
    <footer className="py-12 bg-gray-800">
      <div className="container mx-auto px-6">
        <div className="text-center">
          <div className="flex items-center justify-center mb-4">
            <LogoDark className="h-8 w-auto mr-2" />
          </div>
          <p className="text-gray-400 mb-6 hover:text-gray-300 transition-colors duration-100 cursor-pointer">
            Профессиональные текстильные стропы напрямую от казахстанского производителя
          </p>
          <div className="flex justify-center space-x-6 mb-6">
            <a
              href="tel:+77785929644"
              className="text-gray-400 hover:text-orange-400 transition-colors duration-100 cursor-pointer"
            >
              Телефон
            </a>
            <a
              href="mailto:info@integra-n.kz"
              className="text-gray-400 hover:text-orange-400 transition-colors duration-100 cursor-pointer"
            >
              Email
            </a>
            <a
              href={StKzPdf}
              target="_blank"
              rel="noreferrer"
              className="text-gray-400 hover:text-orange-400 transition-colors duration-100 cursor-pointer"
            >
              Сертификат СТ-KZ
            </a>
            <a
              href="https://api.whatsapp.com/send?phone=77785929644"
              className="text-gray-400 hover:text-orange-400 transition-colors duration-100 cursor-pointer"
            >
              WhatsApp
            </a>
          </div>
          <p className="text-gray-500 text-sm hover:text-gray-400 transition-colors duration-100 cursor-pointer">
            © 2025 INTEGRA. Все права защищены.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
